<template>
  <el-form :model='form' label-width='140px' label-position='right' ref='ruleForm' class='p10 formHeight infoForm'>
    <div-border label='基础信息' class='p20'>
      <el-row :gutter='10'>
        <el-col :span='12'>
          <el-form-item label='对账单编号：'>
            <span>{{ form.settNo | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='对账单标题：'>
            <span>{{ form.title | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='委托商：'>
            <span>{{ form.title | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='结算方式：'>
            <span>{{ form.settType | settTypeFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='合计含税费用：'>
            <span>{{ form.taxPrice | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='合计不含税费用：'>
            <span>{{ form.noTaxPrice | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='台账月汇总金额：'>
            <span>{{ form.statistics | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='是否开具销售清单：'>
            <span>{{ form.isDetailedList | isDetailedListFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='交付方式：'>
            <span>{{ form.pushType | pushTypeFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票种类：'>
            <span>{{ form.invoiceLine | invoiceLineFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='开票类型：'>
            <span>{{ form.invoiceBlueOrRed | invoiceBlueOrRedFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='发票标识：'>
            <span>{{ form.invoiceFlag | invoiceFlagFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='代开标志：'>
            <span>{{ form.proxyInvoiceFlag | proxyInvoiceFlagFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='税率原因说明：'>
            <span>{{ form.specialTaxRateReason | specialTaxRateReasonFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='收款人：'>
            <span>{{ form.payee | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='复核：'>
            <span>{{ form.reviewer | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item label='开票人：'>
            <span>{{ form.drawer | valFormat }}</span>
          </el-form-item>
        </el-col>
        <el-col :span='24'>
          <el-form-item label='备注：'>
            <span>{{ form.invoiceRemark | valFormat }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div-border>

    <div-border label='操作记录' class='p20'>
      <el-table ref='registerTable' row-key='id' :data='form.operateRecordList' style='width: 100%' border
        :header-cell-style='headerCellStyle'>
        <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
        <el-table-column prop='operateType' label='操作类型' align='center' />
        <el-table-column prop='operationName' label='操作人' align='center' />
        <el-table-column prop='remark' label='备注' align='center' />
      </el-table>
    </div-border>
  </el-form>
</template>

<script>
import DivBorder from '@/components/divBorder';

export default {
  name: 'basicInformation',
  components: { DivBorder },
  props: {
    form: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
    };
  },
  filters: {
    valFormat(str) {
      if (str) {
        return str;
      } else {
        return '无';
      }
    },
    isDetailedListFormat(str) {
      return str === 1 ? '是' : str === 0 ? '否' : '无';
    },
    invoiceBlueOrRedFormat(str) {
      return str === 1 ? '红字发票' : str === 0 ? '蓝字发票' : '无';
    },
    pushTypeFormat(str) {
      switch (str) {
        case -1:
          return '不交付';
        case 0:
          return '邮箱交付';
        case 1:
          return '手机交付';
        case 2:
          return '邮箱、手机交付';
      }
    },
    invoiceLineFormat(str) {
      switch (str) {
        case 0:
          return '增值税专用发票';
        case 2:
          return '增值税普通发票(纸票)';
        case 12:
          return '机动车销售统一发票';
        case 41:
          return '增值税普通发票(卷式)';
        case 42:
          return '二手车销售统一发票';
        case 51:
          return '增值税普通电子发票';
        case 52:
          return '增值税专用电子发票';
      }
    },
    invoiceFlagFormat(str) {
      switch (str) {
        case 0:
          return '普通发票';
        case 1:
          return '成品油发票';
        case 2:
          return '收购发票';
        case 3:
          return '机动车发票';
      }
    },
    proxyInvoiceFlagFormat(str) {
      switch (str) {
        case 0:
          return '非代开';
        case 1:
          return '待开';
      }
    },
    settTypeFormat(str) {
      switch (str) {
        case 1:
          return '合同价';
        case 2:
          return '合同价';
      }
    },
    specialTaxRateReasonFormat(str) {
      switch (str) {
        case 0:
          return '无理由';
        case 1:
          return '政策出台前发生纳税义务';
        case 2:
          return '前期已开具相应征收率发票，发生销售折让、中止或者退回等情形需要开具红字发票，或者开票有误需要重新开具';
        case 3:
          return '因为实际经营业务需要，放弃享受免征增值税政策';
      }
    },
  },
};
</script>

<style scoped></style>
